import * as tslib_1 from "tslib";
import _ from 'lodash';
import { FilterConfigType, FilterType, FilterTypeForFetch, } from '../types/types';
var FilterConfigsService = /** @class */ (function () {
    function FilterConfigsService(filterConfigDTOs, deprecatedFilterConfigDTOs, sdkBooleans, multilingualService, translations) {
        this.filterConfigDTOs = filterConfigDTOs;
        this.deprecatedFilterConfigDTOs = deprecatedFilterConfigDTOs;
        this.sdkBooleans = sdkBooleans;
        this.multilingualService = multilingualService;
        this.translations = translations;
        this.areFilterConfigsSavedInSdkBooleans = false;
        this.markAreFilterConfigsSavedInSdkBooleans();
        if (!this.areFilterConfigsSavedInSdkBooleans) {
            this.initFilterConfigs();
        }
    }
    FilterConfigsService.prototype.getFilterTypeDTOs = function () {
        var _this = this;
        var filterTypeDTOs = [];
        if (!this.areFilterConfigsSavedInSdkBooleans) {
            filterTypeDTOs = this.filterConfigs.map(function (filterConfig) {
                return _this.getFilterTypeDTO(filterConfig);
            });
        }
        else {
            this.sdkBooleans.galleryFiltersCategories && filterTypeDTOs.push(FilterTypeForFetch.CATEGORY);
            this.sdkBooleans.galleryFiltersPrice && filterTypeDTOs.push(FilterTypeForFetch.PRICE);
            this.sdkBooleans.galleryFiltersProductOptions && filterTypeDTOs.push(FilterTypeForFetch.OPTIONS);
        }
        return _.uniq(filterTypeDTOs);
    };
    FilterConfigsService.prototype.getFilterConfigTitle = function (filterType) {
        var filterConfigType = this.convertToFilterConfigType(filterType);
        if (!this.areFilterConfigsSavedInSdkBooleans) {
            return this.filterConfigs.find(function (fc) { return fc.filterType === filterConfigType; }).filterTitle;
        }
        else {
            return this.getDefaultFilterTitle(filterConfigType);
        }
    };
    FilterConfigsService.prototype.getCustomCollectionFilterConfigs = function () {
        /* istanbul ignore next */
        if (!this.areFilterConfigsSavedInSdkBooleans) {
            return this.filterConfigs.filter(function (fc) { return fc.custom; });
        }
        else {
            return [];
        }
    };
    FilterConfigsService.prototype.getCollectionFilterConfigs = function () {
        if (!this.areFilterConfigsSavedInSdkBooleans) {
            return this.filterConfigs.filter(function (fc) { return fc.filterType === FilterConfigType.CATEGORY && !fc.custom; });
        }
        else {
            return [];
        }
    };
    FilterConfigsService.prototype.shouldShowFilters = function () {
        if (!this.areFilterConfigsSavedInSdkBooleans) {
            return this.filterConfigs.length !== 0;
        }
        else {
            /* istanbul ignore next: todo(daniela): test this */
            return (this.sdkBooleans.galleryFiltersCategories ||
                this.sdkBooleans.galleryFiltersPrice ||
                this.sdkBooleans.galleryFiltersProductOptions);
        }
    };
    FilterConfigsService.prototype.getEnabledFilterOptionsFromFilterConfig = function (filterOptions, filterConfig) {
        var _this = this;
        return filterOptions
            .filter(function (filterOption) { return _this.getEnabledFilterOptions(filterOption, filterConfig); })
            .sort(function (fo1, fo2) { return _this.sortCollections(fo1, fo2, filterConfig); });
    };
    FilterConfigsService.prototype.removeCustomCollectionFiltersWithNoOptions = function (filterOptions) {
        var _this = this;
        _.remove(this.filterConfigs, function (filterConfig) {
            return (filterConfig.filterType === _this.convertToFilterConfigType(FilterType.CUSTOM_COLLECTION) &&
                _this.getEnabledFilterOptionsFromFilterConfig(filterOptions, filterConfig).length === 0);
        });
    };
    FilterConfigsService.prototype.getEnabledFilterOptions = function (filterOption, filterConfig) {
        return !!_.find(filterConfig.selected, { id: filterOption.key });
    };
    FilterConfigsService.prototype.sortCollections = function (fo1, fo2, filterConfig) {
        return _.findIndex(filterConfig.selected, { id: fo1.key }) - _.findIndex(filterConfig.selected, { id: fo2.key });
    };
    FilterConfigsService.prototype.getFilterTypeDTO = function (filterConfig) {
        if (filterConfig.custom) {
            return FilterTypeForFetch.FILTERED_CATEGORIES;
        }
        switch (filterConfig.filterType) {
            case FilterConfigType.CATEGORY:
                return FilterTypeForFetch.CATEGORY;
            case FilterConfigType.PRICE:
                return FilterTypeForFetch.PRICE;
            case FilterConfigType.OPTIONS:
                return FilterTypeForFetch.OPTIONS;
            /* istanbul ignore next*/
            case FilterConfigType.OPTION_LIST:
            /* istanbul ignore next*/
            default:
                return FilterTypeForFetch.OPTIONS;
        }
    };
    FilterConfigsService.prototype.convertToFilterConfigType = function (filterType) {
        switch (filterType) {
            case FilterType.COLLECTION:
                return FilterConfigType.CATEGORY;
            case FilterType.CUSTOM_COLLECTION:
                return FilterConfigType.OPTION_LIST;
            case FilterType.PRICE:
                return FilterConfigType.PRICE;
            /* istanbul ignore next: todo(daniela): test this */
            case FilterType.COLOR_OPTION:
            /* istanbul ignore next: todo(daniela): test this */
            case FilterType.LIST_OPTION:
                return FilterConfigType.OPTIONS;
            /* istanbul ignore next:*/
            default:
                return FilterConfigType.OPTIONS;
        }
    };
    FilterConfigsService.prototype.initFilterConfigs = function () {
        if (this.filterConfigDTOs) {
            this.filterConfigs = this.toFilterConfigs(this.filterConfigDTOs);
        }
        else {
            this.filterConfigs = this.deprecatedFilterConfigDTOs;
        }
        this.filterConfigs = this.filterConfigs.filter(function (fc) { return fc.show === true; });
    };
    FilterConfigsService.prototype.toFilterConfigs = function (filterConfigDTOs) {
        var _this = this;
        return filterConfigDTOs.map(function (fcDTO) {
            return tslib_1.__assign({}, fcDTO, { filterTitle: _this.getFilterTitle(fcDTO) });
        });
    };
    FilterConfigsService.prototype.getFilterTitle = function (filterConfigDTO) {
        var filterTitle;
        filterTitle = this.multilingualService.get(filterConfigDTO.id);
        /* istanbul ignore else: todo(daniela): test this */
        if (!filterTitle) {
            filterTitle = this.getDefaultFilterTitle(filterConfigDTO.filterType);
        }
        return filterTitle;
    };
    FilterConfigsService.prototype.getDefaultFilterTitle = function (filterType) {
        switch (filterType) {
            case FilterConfigType.CATEGORY:
                return this.translations['gallery.filters.filterList.items.collection.label'];
            case FilterConfigType.PRICE:
                return this.translations['gallery.filters.filterList.items.price.label'];
            case FilterConfigType.OPTIONS:
                return this.translations['gallery.filters.filterList.items.productOptions.label'];
            case FilterConfigType.OPTION_LIST:
                return this.translations['gallery.filters.filterList.items.custom.label'];
        }
    };
    FilterConfigsService.prototype.markAreFilterConfigsSavedInSdkBooleans = function () {
        if (!this.filterConfigDTOs && !this.deprecatedFilterConfigDTOs) {
            this.areFilterConfigsSavedInSdkBooleans = true;
        }
    };
    return FilterConfigsService;
}());
export { FilterConfigsService };
//# sourceMappingURL=filterConfigsService.js.map